import React from "react";
import DOMPurify from "dompurify";
import parse from "html-react-parser";

const HighlightedText = ({
  text = "",
  searchText = "",
  partialSearch = true,
}) => {
  try {
    const isString = typeof text === "string";
    const safeText = isString ? DOMPurify.sanitize(text) : text;

    const isHtml =
      isString && /<\/?[a-z][\s\S]*>/i.test(safeText.toString().trim());

    if (!searchText?.trim()) {
      if (isHtml) return <>{parse(safeText)}</>;
      return <>{safeText}</>;
    }

    const words = searchText.trim().split(/\s+/).filter(Boolean);

    if (words.length === 0) {
      if (isHtml) return <>{parse(safeText)}</>;
      return <>{safeText}</>;
    }

    // Escape special characters for regex
    const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    let regex;

    if (partialSearch) {
      // 🔍 Exact substring match (your requirement)
      regex = new RegExp(`(${escapeRegExp(searchText)})`, "gi");
    } else {
      // 🔍 Partial match (default behavior)
      regex = new RegExp(`(${words.map(escapeRegExp).join("|")})`, "gi");
    }

    const highlightMatches = (content) => {
      if (typeof content !== "string") return content;

      return content?.split(regex).map((part, i) =>
        regex.test(part) ? (
          <mark key={i} style={{ backgroundColor: "yellow" }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        ),
      );
    };

    if (isHtml) {
      return parse(safeText, {
        replace: (node) => {
          if (node.type === "text") {
            return <>{highlightMatches(node.data)}</>;
          }
          return undefined;
        },
      });
    }

    return <>{highlightMatches(safeText)}</>;
  } catch (error) {
    console.error("Error in HighlightedText:", error);
    return <>{typeof text === "string" ? text : ""}</>;
  }
};

export default HighlightedText;
